export type SelectedRescheduleOption = {
  externalEventId: string;
  duration: number;
  title: string;
  proposedStartTimeISO: string;
  currentStartTimeISO: string;
  id: string;
};
export enum RescheduleEventModalActions {
  AddSelectedRescheduleOption = "RescheduleEventModal_AddSelectedRescheduleOption",
  ClearSelectedRescheduleOption = "RescheduleEventModal_ClearSelectedRescheduleOption",
}

export const addSelectedRescheduleOption = (
  selectedRescheduleOption: SelectedRescheduleOption,
) => ({
  type: RescheduleEventModalActions.AddSelectedRescheduleOption,
  data: {
    selectedRescheduleOption: selectedRescheduleOption,
  },
});

export const clearSelectedRescheduleOption = () => ({
  type: RescheduleEventModalActions.ClearSelectedRescheduleOption,
  data: {
    selectedRescheduleOption: null,
  },
});
